import { Button } from "@/components/ui/button";
import { LucideIcon } from "lucide-react";
import { ReactNode } from "react";

interface CTAButtonProps {
  onClick?: () => void;
  href?: string;
  icon: LucideIcon;
  children: ReactNode;
  variant?: "outline" | "default";
  size?: "default" | "lg";
  className?: string;
  disabled?: boolean;
  type?: "button" | "submit" | "reset";
}

export const CTAButton = ({ 
  onClick, 
  href, 
  icon: Icon, 
  children,
  variant = "outline",
  size = "lg",
  className = "",
  disabled = false,
  type = "button"
}: CTAButtonProps) => {
  const baseStyles = "w-auto px-8 sm:px-12 bg-transparent font-semibold text-base";
  
  if (href) {
    return (
      <Button variant={variant} size={size} asChild className={`${baseStyles} ${className}`}>
        <a href={href}>
          {children}
          <Icon className="ml-2 w-5 h-5" />
        </a>
      </Button>
    );
  }
  
  return (
    <Button 
      variant={variant} 
      size={size} 
      onClick={onClick}
      disabled={disabled}
      type={type}
      className={`${baseStyles} ${className}`}
    >
      {children}
      <Icon className="ml-2 w-5 h-5" />
    </Button>
  );
};
